import { render, staticRenderFns } from "./FeedbackDetails.vue?vue&type=template&id=93233672&"
import script from "./FeedbackDetails.vue?vue&type=script&lang=ts&"
export * from "./FeedbackDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports